/* sm-vs-listaverk.js - artwork labels ("Skilti fyrir listaverk") on the one page kit (adapter 'listaverk').
   Samraeming L5 (2026-09-29): the old page sm-listaverk.js moved onto sections/sm-vel.liquid. Engine
   assets/sm-barm-vel.js (window.SMBarm, multi field templates), looks in assets/sm-listaverk-snidmat.json.
   Steps (template block order): Snid A to D (engine tiles, look names only) -> Upplysingar um verkid (the fields,
   built here once) -> Letur (kit letur tiles: the artist's name in each font on the chosen material, style
   names) -> Efni (ONE grid of the 12 materials drawn by the engine, grouped Tvilitt akryl / Stal og messing) ->
   Staerd -> Logo (Nei / Ja) + the logo file (sm-skra) -> Rammi (kit block) -> Fjoldi -> Athugasemd til okkar.
   Variant: picked here (afbrigdi) from material, size, logo and frame. Option 3 is "Logo" today (Nei / Ja); the
   proposed "Logo og rammi" (Nei / Ja / Rammi / Logo og rammi, metal only) is read by value NAME through the
   same map the kit uses (adapter_stillingar.samsett), so both product structures work. Frame: one score line
   3 mm in on acrylic (free), the engraved 0.5 mm band on steel and brass (the +1.000 kr variant; while it does
   not exist the kit says "Ekki i bodi" and stops the add). Looks C (Skra) and D (Klassiskt) keep their own
   frame (step hidden). The frame is drawn by SMVelSida.rammi (the same numbers as a production file) and
   written into the JSON record (_framleidsla.rammi); there is no production file on this line today.
   14.10 (owner: "alltof langt ferli"): with section setting takkar (data-takkar) the steps Snid, Logo and Rammi become pills on the
  strip under the preview (ctx.takkar; they click the same radios, so price, variant, cart and production file are unchanged), the logo file
  field moves INSIDE the Upplysingar step (bottom) and shows when Logo is on, and Upplysingar shows three fields (name, title, year)
  with the rest under "Fleiri upplysingar". Without data-takkar nothing of this runs. 5 steps: Upplysingar, Letur, Efni, Staerd, Fjoldi.
  Cart: Utlit, Leturgerd (style name; the real font goes in the hidden _letur), the fields, Rammi,
   Athugasemd. ES5, ASCII only, no customer text here (ctx.vel.ord from snippets/sm-vl-listaverk.liquid). */
(function () {
  'use strict';
  function B() { return window.SMBarm; }
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function trim(t) { return String(t == null ? '' : t).replace(/^\s+|\s+$/g, ''); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function thus(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function kr(a) { var n = Math.round((Number(a) || 0) / 100); return (n < 0 ? '-' : '') + thus(Math.abs(n)) + ' kr.'; }
  function munurKr(a) { return (a > 0 ? '+' : '-') + thus(Math.round(Math.abs(a) / 100)) + ' kr.'; }
  function tx(o) { return !o ? '' : typeof o === 'string' ? o : (o.is || ''); }
  /* F1 23.10 (T3): engine messages in the shop language from ord.<kodi>.en in sm-listaverk-snidmat.json (the engine gives .is);
     tx() stays Icelandic for the cart and the production */
  function vTexti(v) {
    if (!v || erIslenska()) return v ? v.texti : '';
    var Tm = T(), R = v.reitur && Tm && Tm.reitir && Tm.reitir[v.reitur], o = R && R.ord && R.ord[v.kodi];
    return (o && o.en) || (/of_langt|of_langur/.test(String(v.kodi)) ? t('of_langt') : '') || v.texti;
  }
  function r3(n) { return Math.round(n * 1000) / 1000; }
  var TAKN_RE;
  try { TAKN_RE = new RegExp('[\\p{Extended_Pictographic}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{E0020}-\\u{E007F}\\u20E3\\uFE0E\\uFE0F\\u200D]', 'gu'); }
  catch (e) { TAKN_RE = /[\uD83C-\uDBFF][\uDC00-\uDFFF]|[\u2190-\u21ff\u2300-\u23ff\u2460-\u24ff\u25a0-\u27bf\u2900-\u297f\u2b00-\u2bff\u3030\u303d\u3297\u3299\u20e3\ufe0e\ufe0f\u200d]/g; }

  var REITIR = ['nafn', 'uppruni', 'titill', 'ar', 'taekni', 'maal', 'eign', 'nr', 'texti'];
  var LJOST = { 'tvilitt-hvitt': 1, 'tvilitt-gull': 1, 'tvilitt-silfur': 1, 'tvilitt-gult': 1, 'tvilitt-hvitt-blatt': 1 };
  var ISO_LITIR = { 'tvilitt-blatt': 1, 'tvilitt-rautt': 1, 'tvilitt-gult': 1, 'tvilitt-graent': 1 };
  var CTX = null;
  var ST = { snid: '', efni: '', staerd: '', logo: 'nei', leturSnert: false, rammiSnert: false, rammiEfni: null, logoMynd: null, logoSkra: null, logoNr: 0, logoSkb: '', snert: false };
  REITIR.forEach(function (k) { ST[k] = ''; });
  var SNID = {}, LISTI = [], TILBUID = false, LETUR_KLAR = false, HLADID = null;

  function V() { return (CTX && CTX.vel) || {}; }
  function ORD() { return V().ord || {}; }
  function t(k, b) { var s = ORD()[k]; s = s == null ? '' : String(s); if (b) s = s.replace(/\{(\w+)\}/g, function (m, n) { return b[n] != null ? String(b[n]) : m; }); return s; }
  function S() { return (CTX && CTX.stillingar) || {}; }

  /* ---------- options by role and position ---------- */
  function hlutverk() { return S().hlutverk || ['efni', 'staerd', 'logo']; }
  function kodar(h) { return (S().kodar || {})[h] || []; }
  function stadur(h) { return hlutverk().indexOf(h); }
  function valkostir() { return (CTX && CTX.gogn && CTX.gogn.valkostir) || []; }
  function shopKodi(h, k) { var i = stadur(h), j = kodar(h).indexOf(k), o = valkostir()[i]; return i < 0 || j < 0 || !o || !o.gildi[j] ? null : String(o.gildi[j].kodi); }
  function hlutKodi(h, shop) { var i = stadur(h), o = valkostir()[i], j; if (i < 0 || !o) return null; for (j = 0; j < o.gildi.length; j++) if (String(o.gildi[j].kodi) === String(shop)) return kodar(h)[j] || null; return null; }
  /* option 3 by the composite map (samsett): "logo|rammi" -> value NAME (today: Nei, Ja; proposed: + Rammi, Logo og rammi) */
  function samsett() { var s = S().samsett; return s && s[0] ? s[0] : null; }
  function logoGildi(logo, rammi) {
    var p = stadur('logo'), o = valkostir()[p], sm = samsett(), nafn, j;
    if (!o) return null;
    nafn = sm && sm.kodar ? sm.kodar[logo + '|' + rammi] : null;
    for (j = 0; j < o.gildi.length; j++) if (nafn != null && (o.gildi[j].nafn === nafn || String(o.gildi[j].kodi) === nafn)) return String(o.gildi[j].kodi);
    return rammi === 'an' ? shopKodi('logo', logo) : null;
  }
  function logoAfKoda(shop) {
    var p = stadur('logo'), o = valkostir()[p], sm = samsett(), j, k, nafn = null;
    if (!o) return null;
    for (j = 0; j < o.gildi.length; j++) if (String(o.gildi[j].kodi) === String(shop)) nafn = o.gildi[j].nafn;
    if (sm && sm.kodar) for (k in sm.kodar) if (has(sm.kodar, k) && sm.kodar[k] === nafn) return k.split('|')[0];
    return hlutKodi('logo', shop);
  }
  function afbrigdin() { return (CTX && CTX.gogn && CTX.gogn.afbrigdi) || []; }
  function finnaKoda(want) {
    var A = afbrigdin(), i, j, ok;
    for (i = 0; i < A.length; i++) {
      ok = true;
      for (j = 0; j < want.length; j++) if (want[j] == null || String(A[i].o[j]) !== String(want[j])) { ok = false; break; }
      if (ok) return A[i];
    }
    return null;
  }
  /* k = { efni, staerd, logo, rammi }; a free frame without its own value uses the plain value (sparse rule) */
  function finna(k) {
    var p = [stadur('efni'), stadur('staerd'), stadur('logo')], want = [], a;
    want[p[0]] = shopKodi('efni', k.efni); want[p[1]] = shopKodi('staerd', k.staerd);
    want[p[2]] = logoGildi(k.logo, k.rammi === 'med' ? 'med' : 'an');
    a = want[p[2]] != null ? finnaKoda(want) : null;
    if (!a && k.rammi === 'med') { want[p[2]] = logoGildi(k.logo, 'an'); a = finnaKoda(want); }
    return a;
  }
  /* the text lines of an engine SVG ({ a: attributes, t: text }) and one line's width in its own units (canvas
     measure in the line's font, a rough estimate without canvas) */
  function svgLinur(svg) {
    var re = /<text\b([^>]*)>([\s\S]*?)<\/text>/g, m, am, ut = [];
    while ((m = re.exec(svg))) {
      var a = {}, re2 = /([\w-]+)="([^"]*)"/g;
      while ((am = re2.exec(m[1]))) a[am[1]] = am[2].replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&');
      ut.push({ a: a, t: m[2].replace(/<[^>]+>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&') });
    }
    return ut;
  }
  var MAEL = null;
  function linuBreidd(a, txt) {
    var fs = parseFloat(a['font-size']) || 4, ls = parseFloat(a['letter-spacing']) || 0, w = 0;
    try {
      MAEL = MAEL || document.createElement('canvas').getContext('2d');
      MAEL.font = (a['font-style'] || 'normal') + ' ' + (a['font-weight'] || '400') + ' 100px ' + (a['font-family'] || 'sans-serif');
      w = MAEL.measureText(txt).width * fs / 100;
    } catch (e) { w = 0; }
    if (!w) w = txt.length * fs * 0.56;
    return w + Math.max(0, txt.length - 1) * ls;
  }
  function vbAf(svg) { var m = /viewBox="([^"]+)"/.exec(svg), v = m ? m[1].split(/[\s,]+/).map(Number) : null; return v && v.length === 4 && v[2] > 0 && v[3] > 0 ? v : null; }
  /* material tiles: a close-up around the artist's name (the largest line). The whole label drew the name about
     5 px high on a phone, so black lettering and a plain engraving on steel looked the same (fix round 1) */
  function naermynd(svg, me) {
    var L = svgLinur(svg), V0 = vbAf(svg), n = null, i;
    if (!L.length || !V0) return svg;
    for (i = 0; i < L.length; i++) if (trim(L[i].t) && (!n || (parseFloat(L[i].a['font-size']) || 0) > (parseFloat(n.a['font-size']) || 0))) n = L[i];
    if (!n) return svg;
    var fs = parseFloat(n.a['font-size']) || 4, x = parseFloat(n.a.x) || 0, y = parseFloat(n.a.y) || 0, w = linuBreidd(n.a, n.t), anc = n.a['text-anchor'];
    var x0 = anc === 'middle' ? x - w / 2 : anc === 'end' ? x - w : x;
    /* E5: the window stays inside the plate face past the frame band (plate 0..b x 0..h mm) */
    var IM = 4.5, I = me && me.b > 2 * IM + 4 && me.h > 2 * IM + 3 ? [IM, IM, me.b - 2 * IM, me.h - 2 * IM] : V0;
    var W = Math.min(I[2], Math.max(I[2] * 0.45, w + 2 * Math.max(4, fs))), H = W * 0.75;
    if (H > I[3]) { H = I[3]; W = Math.min(I[2], H / 0.75); }
    var X = Math.max(I[0], Math.min(I[0] + I[2] - W, x0 + w / 2 - W / 2)), Y = Math.max(I[1], Math.min(I[1] + I[3] - H, y - fs * 0.35 - H * 0.36));
    /* never cut a line in half at the bottom edge: end the window just above it */
    for (i = 0; i < L.length; i++) {
      var f2 = parseFloat(L[i].a['font-size']) || 0, y2 = parseFloat(L[i].a.y) || 0, top = y2 - f2 * 0.8, bot = y2 + f2 * 0.25;
      if (trim(L[i].t) && top < Y + H && bot > Y + H && top - H - 0.4 >= I[1] - 0.01 && top - H - 0.4 <= y - fs * 0.9) Y = top - H - 0.4;
    }
    var nb = 0;
    for (i = 0; i < L.length; i++) {
      var f3 = parseFloat(L[i].a['font-size']) || 0, y3 = parseFloat(L[i].a.y) || 0;
      if (trim(L[i].t) && y3 - f3 * 0.8 < Y + H && y3 + f3 * 0.25 + 1.5 > Y + H) nb = Math.max(nb, y3 + f3 * 0.25);
    }
    if (nb) {
      var H2 = nb + 1.5 - Y, W2 = Math.max(W, H2 / 0.75);
      if (W2 <= I[2] + 0.001 && Y + H2 <= I[1] + I[3] + 0.001) { W = W2; H = W2 * 0.75; X = Math.max(I[0], Math.min(I[0] + I[2] - W, x0 + w / 2 - W / 2)); Y = Math.max(I[1], Math.min(I[1] + I[3] - H, (y - fs * 0.8 + nb) / 2 - H / 2)); }
    }
    return svg.replace(/viewBox="[^"]*"/, 'viewBox="' + r3(X) + ' ' + r3(Y) + ' ' + r3(W) + ' ' + r3(H) + '" preserveAspectRatio="xMidYMid slice"');
  }
  /* strips emoji; where one was removed, the spaces around it close up to one */
  function eittBil(v) { var n = String(v).replace(TAKN_RE, ''); return n === v ? v : n.replace(/[ \t]{2,}/g, ' '); }
  /* the frame the kit settles on this round. The kit flips an untouched frame to the material's default only
     AFTER afbrigdi, so on acrylic (frame on) -> steel/brass (frame off) the radio still says "med" here and the
     paid frame variant would be picked. Untouched = no click, no ?rammi=, and the step still equals the default
     of the material it was last settled for (a kit API choice shows up as a difference) */
  function rammiSjalf(efni) {
    var rs = CTX && CTX.skref ? CTX.skref('rammi') : null, el = rs && rs.el, E = B();
    var malm = !!(E && E.EFNI && E.EFNI[efni] && E.EFNI[efni].fj === 'malmur');
    if (!el) return malm ? 'an' : 'med';
    return malm ? (el.getAttribute('data-sjalfgefid-malmur') === 'med' ? 'med' : 'an') : (el.getAttribute('data-sjalfgefid') === 'an' ? 'an' : 'med');
  }
  function rammiNu(s) {
    var r = s && s.rammi;
    if (!r || !(CTX && CTX.skref && CTX.skref('rammi'))) return r;
    if (!ST.rammiSnert && ST.rammiEfni === ST.efni && r !== rammiSjalf(ST.efni)) ST.rammiSnert = true;
    ST.rammiEfni = ST.efni;
    return ST.rammiSnert ? r : rammiSjalf(ST.efni);
  }
  /* the frame a material tile's price is for: the customer's own choice, or while untouched that material's default */
  function rammiEfnis(s, efni) { var r = s && s.rammi; return !r || ST.rammiSnert ? r : rammiSjalf(efni); }
  function val(s, o) { var k = { efni: ST.efni, staerd: ST.staerd, logo: ST.logo, rammi: s && s.rammi }, x; for (x in o) if (has(o, x)) k[x] = o[x]; return k; }
  function munur(s, a, b) { var va = finna(val(s, a)), vb = finna(val(s, b)); return va && vb ? vb.verd - va.verd : 0; }

  /* ---------- engine data ---------- */
  function T(k) { return SNID[k || ST.snid] || LISTI[0] || null; }
  function leturMap() { return S().letur || {}; }
  /* the page's font id (kit letur step) -> the template's font key (letur_val) */
  function leturKey(id) { var m = leturMap(), k; for (k in m) if (has(m, k) && m[k] === id) return k; return null; }
  function leturAf(Tm, s) {
    var k = leturKey(s && s.letur);
    return Tm && k && Tm.letur_val && Tm.letur_val[k] ? k : (Tm && Tm.letur_sjalfgefid) || null;
  }
  function notarNr(Tm) { return !!(Tm && Tm.radir && Tm.radir.nr); }
  function skrifad() { return REITIR.some(function (k) { return !!trim(ST[k]); }); }
  function gogn(Tm, syn, s, o) {
    o = o || {};
    var d = { efni: o.efni || ST.efni, staerd: o.staerd || ST.staerd, letur: o.letur !== undefined ? o.letur : leturAf(Tm, s), logo: ST.logo === 'ja' ? (ST.logoMynd || 'stadgengill') : null };
    var daemi = syn && !skrifad();
    REITIR.forEach(function (k) { d[k] = daemi ? t('daemi.' + k) : trim(ST[k]); });
    if (!notarNr(Tm)) d.nr = '';
    return d;
  }
  /* the frame of a look and material: acrylic one score line 3 mm in, metal the 0.5 mm band; C and D keep their own */
  /* owner 30.09: a frame on metal only on door signs, so none on steel or brass artwork labels (the step is hidden).
     RAMMI_MALMUR = true brings back the engraved metal band here. */
  var RAMMI_MALMUR = false;
  function rammiGeo(Tm, efni) {
    if (!Tm || (S().eiginRammi || ['skra', 'klassiskt']).indexOf(Tm.key) >= 0) return { gerd: null };
    var E = B() && B().EFNI && B().EFNI[efni];
    if (E && E.fj === 'malmur') return RAMMI_MALMUR ? { gerd: 'malmur', inset: 3, band: 0.5, verd: 'malmur' } : { gerd: null };
    return { gerd: 'lina', inset: 3, insetY: 3, r: 0, form: 'rett', verd: 'okeypis' };
  }
  function logoLysing() {
    var el = CTX && CTX.rot && CTX.rot.querySelector('[data-sm-skra-texti]');
    return el ? trim(el.value) : '';
  }
  /* The 12 engraving fonts the label templates use and SMFram does not carry (02.10, from listaverk-framleidsla:
     OFL Google Fonts static files, subset, as assets/sm-letur-<id>.json). The URLs come from snippets/sm-vl-listaverk.liquid
     (window.SMListaverkLetur), the metadata is here; registered with SMFram.skraLetur only when SMFram lacks the font. */
  var FRAM_LETUR = {
    'archivo-400': ['Archivo', 400, 0, 'archivo v25'], 'archivo-500': ['Archivo', 500, 0, 'archivo v25'],
    'archivo-700': ['Archivo', 700, 0, 'archivo v25'], 'archivo-italic-400': ['Archivo', 400, 1, 'archivo v25'],
    'cormorantgaramond-700': ['Cormorant Garamond', 700, 0, 'cormorantgaramond v21'],
    'cormorantgaramond-italic-500': ['Cormorant Garamond', 500, 1, 'cormorantgaramond v21'],
    'ibmplexmono-400': ['IBM Plex Mono', 400, 0, 'ibmplexmono v20', 'SM Mono'], 'ibmplexmono-500': ['IBM Plex Mono', 500, 0, 'ibmplexmono v20', 'SM Mono'],
    'ibmplexmono-600': ['IBM Plex Mono', 600, 0, 'ibmplexmono v20', 'SM Mono'], 'ibmplexmono-italic-400': ['IBM Plex Mono', 400, 1, 'ibmplexmono v20', 'SM Mono'],
    'jost-600': ['Jost', 600, 0, 'jost v20'], 'jost-italic-400': ['Jost', 400, 1, 'jost v20']
  };
  function framLetur() {
    var F = window.SMFram, sl = window.SMListaverkLetur || {}, id, L;
    if (!F || !F.skraLetur || !F.hefurLetur) return;
    /* FB 21.10 (B1): skip only the fonts SMFram's own table knows. hefurLetur() is also true for a bare URL in
       SMFramSlodir.letur (jost-600 since 08.10), and SMFram's spec check then threw letur-vantar on Gallery/Label + Retro. */
    var tafla = F.letur ? F.letur() : null;
    for (id in FRAM_LETUR) {
      if (!has(FRAM_LETUR, id) || !sl[id] || (tafla ? has(tafla, id) : F.hefurLetur(id))) continue;
      L = FRAM_LETUR[id];
      try { F.skraLetur(id, { url: sl[id], nafn: L[0], alias: L[4], thykkt: L[1], skaletrad: !!L[2], uppruni: 'Google Fonts ' + L[3] + ', kyrrstaett eintak' }); } catch (e) {}
    }
  }
  function staerdMm(k) { var V0 = B() && B().VORUR && B().VORUR.verkamerki; return V0 && V0.staerdir[k] ? V0.staerdir[k] : null; }
  function svgAf(Tm, D, O, rammi, smamynd) {
    var E = B(); if (!E || !Tm) return '';
    var svg = E.teikna(Tm, D, O);
    var g = rammi === 'med' ? rammiGeo(Tm, D.efni) : { gerd: null }, m = staerdMm(D.staerd);
    if (g.gerd && m && window.SMVelSida && window.SMVelSida.rammi) {
      var EF = E.EFNI[D.efni] || {};
      var r = window.SMVelSida.rammi(m.b, m.h, { gerd: g.gerd, inset: g.inset, insetY: g.insetY, r: g.r, form: g.form, band: g.band, litur: EF.kjarni || '#1a1815', breidd: 0.3, smamynd: !!smamynd });
      svg = svg.replace(/<\/svg>\s*$/, r.svg + '</svg>');
    }
    return svg;
  }
  function stadaNu(s) { var E = B(), Tm = T(); return E && Tm ? E.stada(Tm, gogn(Tm, false, s)) : { ok: false, vandamal: [], falin: [] }; }

  /* ---------- names ---------- */
  function heitiUtlit(k) { var Tm = SNID[k]; return t('utlit.' + k) || (Tm ? (Tm.nr ? Tm.nr + ' \u00b7 ' : '') + tx(Tm.heiti) : k); }
  function heitiUtlitsStutt(k) { var Tm = SNID[k], u = t('utlit.' + k); if (u) return u.replace(/^[A-Z]\s*\u00b7\s*/, ''); return Tm ? tx(Tm.heiti) : k; }
  /* FB 21.10 (E2): the look descriptions exist in Icelandic only; other languages get the look name as title */
  function erIslenska() { var l = String((document.documentElement && document.documentElement.lang) || 'is').toLowerCase(); return l.indexOf('is') === 0; }
  function heitiEfni(k) { return t('efni.' + k) || k; }
  function heitiStaerd(k) { return t('staerd.' + k) || k; }
  function heitiReits(k) { return t('reitur.' + k) || k; }

  /* ---------- the fields: built once, never rebuilt while typing ---------- */
  var athTimi = {};
  function athugasemd(el, k, texti) {
    var p = el.querySelector('[data-lv-ath="' + k + '"]'); if (!p) return;
    p.textContent = texti; clearTimeout(athTimi[k]);
    if (texti) athTimi[k] = setTimeout(function () { p.textContent = ''; }, 8000);
  }
  /* kit units (K-reitur, K-bod, K-tillogur, lota 5 08.10): medAth puts the transient line (emoji / cut text) inside the field,
     tillHtml renders the 'try this' suggestions; the adapter keeps listening to its own data-XX-til buttons */
  function medAth(h, ath) { return h.replace(/<\/div>$/, function () { return ath + '</div>'; }); }
  function tillHtml(ctx, till, gagn) {
    var h = ctx.html.tillogur({ texti: t('reyndu'), kostir: till.map(function (x) { var g = {}; g[gagn] = x.k; return { gildi: x.k, heiti: x.texti, gogn: g }; }) });
    return h.replace(/<\/div>$/, function () { return '<span>' + esc(t('styttra')) + '</span></div>'; });
  }
  function smidaReiti(el, ctx) {
    if (el.__lvReitir) return;
    el.__lvReitir = true;
    var id = 'vs-' + ctx.id + '-lv', rl = {}, tk = erTakkar(ctx);
    REITIR.forEach(function (k) {
      var hj = t('hjalp.' + k), R = T() && T().reitir && T().reitir[k], max = (R && R.max) || (k === 'texti' ? 320 : 60);
      rl[k] = (medAth(ctx.html.reitur({ id: id + '-' + k, heiti: heitiReits(k), valfrjalst: k !== 'nafn', gerd: k === 'texti' ? 'svaedi' : 'texti', linur: 3,
        hamark: max, teljari: k === 'texti', villa: false, synishorn: t('daemi.' + k), hjalp: hj, lysing: id + '-a-' + k, skylda: k === 'nafn', fokus: k,
        attr: { autocomplete: 'off', spellcheck: k === 'texti' ? 'true' : 'false', autocapitalize: k === 'nafn' ? 'words' : null },
        gogn: { 'lv-texti': k }, reitGogn: { 'lv-reitur': k }, falid: k === 'nr' && !notarNr(T()) }),
        ctx.html.bod('', 'hjalp', { id: id + '-a-' + k, gogn: { 'lv-ath': k } })));
    });
    function rodin(l) { return l.map(function (k) { return rl[k]; }); }
    if (tk) {
      /* 14.10: nafn, titill og artal strax; hitt undir "Fleiri upplysingar" (opnast sjalft ef reitur hefur gildi) */
      ctx.html.setja(el, ctx.html.reitir(rodin(SYNT)) +
        '<details class="lv-meira" data-lv-meira><summary><span>' + esc(t('fleiri') || 'Fleiri uppl\u00fdsingar') +
        '<span class="lv-meira-undir">' + esc(t('fleiri_undir') || 'uppruni, t\u00e6kni, st\u00e6r\u00f0, eigandi, texti') + '</span></span></summary>' +
        '<div class="lv-meira-inn">' + ctx.html.reitir(rodin(MEIRA)) + '</div></details><div data-lv-tillogur aria-live="polite"></div>');
    } else ctx.html.setja(el, ctx.html.reitir(rodin(REITIR)) + '<div data-lv-tillogur aria-live="polite"></div>');
    REITIR.forEach(function (k) {
      var inp = el.querySelector('[data-lv-texti="' + k + '"]');
      function hreinsa() {
        /* an emoji between two words leaves two spaces: one is kept ("Helga \ud83d\ude00 D\u00f6gg" -> "Helga D\u00f6gg") */
        var v = inp.value || '', n = eittBil(v);
        if (n === v) return false;
        var pos = typeof inp.selectionStart === 'number' ? inp.selectionStart : v.length, ny = eittBil(v.slice(0, pos)).length;
        inp.value = n;
        try { if (document.activeElement === inp) inp.setSelectionRange(ny, ny); } catch (e) {}
        return true;
      }
      function uppfaera(e) {
        if (e && e.isComposing) return;
        if (hreinsa()) athugasemd(el, k, t('emoji'));
        ST[k] = inp.value || '';
        if (k === 'nafn' && ST.nafn) ST.snert = true;
        ctx.breytt();
      }
      inp.addEventListener('paste', function (e) {
        var cd = e.clipboardData || window.clipboardData, txt = cd && cd.getData ? cd.getData('text') : null;
        if (txt == null) return;
        txt = String(txt).replace(k === 'texti' ? /\r\n|\r/g : /\r\n|\r|\n|\t/g, k === 'texti' ? '\n' : ' ').replace(TAKN_RE, '');
        var v = inp.value || '', s0 = inp.selectionStart || 0, s1 = inp.selectionEnd || 0, max = inp.maxLength;
        var pl = max > 0 ? Math.max(0, max - (v.length - (s1 - s0))) : txt.length;
        if (txt.length > pl) {
          e.preventDefault();
          inp.value = v.slice(0, s0) + txt.slice(0, pl) + v.slice(s1);
          try { inp.setSelectionRange(s0 + pl, s0 + pl); } catch (x) {}
          athugasemd(el, k, t('klippt', { n: max }));
          uppfaera();
        }
      });
      inp.addEventListener('input', uppfaera);
      inp.addEventListener('compositionend', function () { uppfaera(); });
      if (k === 'nafn') inp.addEventListener('blur', function () { ST.snert = true; ctx.uppfaera(); });
      hreinsa();
      ST[k] = inp.value || '';
    });
    if (tk) {
      var det = el.querySelector('[data-lv-meira]');
      if (det) {
        if (meiraHefurGildi(el)) det.open = true;
        det.querySelector('summary').addEventListener('click', function () { ST.meiraSnert = true; });
      }
      /* the logo file step lives at the bottom of Upplysingar (its own step element, so the kit still shows, validates and focuses it);
         hidden from the numbering (data-takka-fel, display restored by the style above) */
      var ls = ctx.skref('logoskra');
      if (ls && ls.el && el.parentNode && ls.el.parentNode !== el.parentNode) {
        ls.el.setAttribute('data-takka-fel', '');
        el.parentNode.insertBefore(ls.el, el.nextSibling);
      }
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-lv-til]') : null;
      if (!b) return;
      var a = b.getAttribute('data-lv-til').split(':');
      if (a[0] === 'staerd') ST.staerd = a[1]; else veljaSnid(a[1], ctx);
      ctx.breytt();
      ctx.tilkynna(a[0] === 'staerd' ? heitiStaerd(a[1]) : heitiUtlit(a[1]), false);
    });
  }
  function tillogur(s) {
    var E = B(), Tm = T(), ut = [];
    if (!E || !Tm || !trim(ST.nafn)) return ut;
    kodar('staerd').forEach(function (k) {
      if (k === ST.staerd || !finna(val(s, { staerd: k }))) return;
      if (E.stada(Tm, gogn(Tm, false, s, { staerd: k })).ok) ut.push({ k: 'staerd:' + k, texti: t('til_staerd', { s: heitiStaerd(k) }) });
    });
    LISTI.forEach(function (Tm2) {
      if (Tm2.key === ST.snid || ut.length >= 3) return;
      if (E.stada(Tm2, gogn(Tm2, false, s)).ok) ut.push({ k: 'snid:' + Tm2.key, texti: t('til_utlit', { s: heitiUtlit(Tm2.key) }) });
    });
    return ut.slice(0, 3);
  }
  /* a look brings its own font until the customer picks one (as the old page) */
  function veljaSnid(k, ctx) {
    ST.snid = k;
    if (ST.leturSnert) return;
    var Tm = SNID[k], id = Tm && leturMap()[Tm.letur_sjalfgefid], ls = ctx.skref('letur');
    if (!id || !ls) return;
    var inn = ls.el.querySelector('input[value="' + id + '"]');
    if (inn && !inn.checked) { inn.checked = true; inn.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function tengja(el, fall) {
    el.__lvFall = fall;
    if (el.__lvTengt) return;
    el.__lvTengt = true;
    el.addEventListener('change', function (e) { var x = e.target; if (x && x.type === 'radio' && el.__lvFall) el.__lvFall(x); });
  }
  function stadaFyrir() {
    var p = window.SMVelSida && window.SMVelSida.sidur, i;
    if (p) for (i = 0; i < p.length; i++) if (p[i].rot === CTX.rot && typeof p[i].stada === 'function') return p[i].stada();
    return { rammi: CTX ? CTX.rammiGildi() : '' };
  }

  /* ---------- takka-hamur (14.10, section setting "takkar" -> data-takkar on .vs) ----------
     Snid (a pair of four), Logo and Rammi (switches) are pills on the strip under the preview (ctx.takkar, same look as the door signs).
     They click EXACTLY the radios of the steps Snid, Logo and Rammi (kept in the DOM, hidden with data-takka-fel), so price, variant, cart
     properties and the production file are the same. The logo file step moves into the Upplysingar step. Without data-takkar none of this runs. */
  var SYNT = ['nafn', 'titill', 'ar'], MEIRA = ['uppruni', 'taekni', 'maal', 'eign', 'nr', 'texti'];
  function erTakkar(ctx) { return !!(ctx && ctx.rot && ctx.rot.hasAttribute && ctx.rot.hasAttribute('data-takkar')); }
  function stilar() {
    if (document.getElementById('lv-stilar')) return;
    var st = document.createElement('style');
    st.id = 'lv-stilar';
    st.textContent = [
      '.lv-meira{margin-top:14px;border:1px solid var(--vs-rule,#d8d3c5);border-radius:10px;background:#fff}',
      '.lv-meira>summary{list-style:none;display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:44px;padding:9px 14px;cursor:pointer;font-family:var(--vs-f-body,inherit);font-size:var(--vs-t-litid,14px);font-weight:600;color:var(--vs-ink,#2e2e2e);border-radius:10px}',
      '.lv-meira>summary::-webkit-details-marker{display:none}',
      '.lv-meira>summary::after{content:"";flex:none;width:8px;height:8px;margin:-4px 3px 0 0;border:solid currentColor;border-width:0 2px 2px 0;transform:rotate(45deg);transition:transform .15s}',
      '.lv-meira[open]>summary::after{margin-top:3px;transform:rotate(225deg)}',
      '.lv-meira>summary:focus-visible{outline:2px solid var(--vs-accent,#d96e1a);outline-offset:2px}',
      '.lv-meira-undir{display:block;margin-top:1px;font-size:12.5px;font-weight:400;color:var(--vs-ink-mute,#746f65)}',
      '.lv-meira-inn{padding:2px 14px 14px}',
      '.vs[data-takkar] fieldset[data-lykill="logoskra"][data-takka-fel]:not([hidden]){display:block !important;margin:18px 0 0;padding:16px 0 0;border:0;border-top:1px solid var(--vs-rule,#d8d3c5)}',
      '.vs[data-takkar] fieldset[data-lykill="logoskra"] .vs-nr{display:none}'
    ].join('\n');
    document.head.appendChild(st);
  }
  function opnaFyrir(x) {
    var d = x && x.closest ? x.closest('details') : null;
    if (d && !d.open) d.open = true;
  }
  function meiraHefurGildi(el) {
    return MEIRA.some(function (k) { var i = el.querySelector('[data-lv-texti="' + k + '"]'); return !!(i && trim(i.value)); });
  }
  function takkaRadio(ctx, l, f) {
    var s = ctx.skref(l), r = s && s.el ? s.el.querySelectorAll('input[type=radio]') : [], i;
    for (i = 0; i < r.length; i++) if (f(r[i])) return r[i];
    return null;
  }
  /* Logo switched on: scroll to the file field (now inside Upplysingar) and put the cursor on it; the block shows after the redraw, so retry */
  function fokusLogo(ctx) {
    var n = 0;
    (function f() {
      var ls = ctx.skref('logoskra'), blokk = ls && ls.el ? ls.el.querySelector('[data-sm-skra]') : null, inn = blokk ? blokk.querySelector('[data-sm-skra-inntak]') : null;
      if (!blokk || !inn || inn.disabled || !blokk.offsetParent) { if (++n < 14) setTimeout(f, 120); return; }
      /* phone: the preview + strip is sticky on top, so the block goes just below it (not the centre of the window); desktop: centre */
      var sv = ctx.rot.querySelector('[data-vs-svid]'), y;
      if (window.innerWidth < 1001 && sv) {
        /* the layout is still settling right after the block appears: scroll, then correct once if it did not land under the preview */
        var ira = function () {
          var oh = (parseFloat(window.getComputedStyle(sv).top) || 0) + sv.offsetHeight + 12;
          y = window.pageYOffset + blokk.getBoundingClientRect().top - oh;
          try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
          return oh;
        };
        var oh0 = ira();
        setTimeout(function () { if (Math.abs(blokk.getBoundingClientRect().top - oh0) > 24) ira(); }, 900);
      } else {
        try { blokk.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e4) { try { blokk.scrollIntoView(); } catch (e2) {} }
      }
      try { inn.focus({ preventScroll: true }); } catch (e3) {}
    })();
  }
  function logoMunur() { return munur(stadaFyrir(), { logo: 'nei' }, { logo: 'ja' }); }
  function takkaSmida(ctx) {
    var hopar, snidPillur;
    snidPillur = LISTI.map(function (Tm) {
      var k = Tm.key;
      return { k: k, t: heitiUtlitsStutt(k), til: function () { return true; }, kv: function () { return ST.snid === k; },
        smella: function (kv) { if (kv) return; var r = takkaRadio(ctx, 'snid', function (x) { return x.value === k; }); if (r) r.click(); } };
    });
    ST.pill = {
      logo: { k: 'logo', t: '+ Logo',
        til: function () { var a = finna(val(stadaFyrir(), { logo: 'ja' })); return !!a && a.til !== false; },
        kv: function () { return ST.logo === 'ja'; },
        smella: function (kv) {
          var r = takkaRadio(ctx, 'logo', function (x) { return x.value === (kv ? 'nei' : 'ja'); });
          if (r) r.click();
          if (!kv) fokusLogo(ctx);
        } },
      rammi: { k: 'rammi', t: ctx.t('rammi') || 'Rammi',
        til: function () { var s = ctx.skref('rammi'); return !!(s && s.synilegt); },
        kv: function () { var r = takkaRadio(ctx, 'rammi', function (x) { return x.checked; }); return !!r && r.value === 'med'; },
        smella: function (kv) { var r = takkaRadio(ctx, 'rammi', function (x) { return x.value === (kv ? 'an' : 'med'); }); if (r) r.click(); } }
    };
    ST.snidPillur = snidPillur;
    hopar = [
      { heiti: t('takki_snid') || 'Sni\u00f0', pillur: snidPillur },
      { heiti: 'Logo', pillur: [ST.pill.logo] },
      { heiti: t('takki_rammi') || 'Rammi', pillur: [ST.pill.rammi] }
    ];
    ST.takkar = ctx.takkar({ fela: ['snid', 'logo', 'rammi'], hopar: hopar });
  }
  /* the toggle pills read "+ Logo" / "\u2713 Logo" (the kit gives single pills no plus sign); the price and the look descriptions go in title */
  function takkaTexti() {
    var P = ST.pill, m, a, b, on, tx2, lab;
    if (!P) return;
    [['logo', 'Logo'], ['rammi', P.rammi.t]].forEach(function (x) {
      var p = P[x[0]]; if (!p.el) return;
      on = !p.el.hidden && !!p.kv();
      tx2 = (on ? '\u2713 ' : '+ ') + x[1];
      /* BOLA-ALLT 22.10: the "+ " / "\u2713 " prefix in its own span, so the glass bubble (sm-vs-bola.css) can leave it out; the strip reads the same */
      if (p.el.textContent !== tx2 || !p.el.querySelector('.vs-takki-forskeyti')) {
        var fk = document.createElement('span');
        fk.className = 'vs-takki-forskeyti';
        fk.setAttribute('aria-hidden', 'true');
        fk.textContent = on ? '\u2713 ' : '+ ';
        /* one inline box for the whole label, so the strip (inline-flex with a gap) lays it out exactly as the plain text before */
        var ut = document.createElement('span');
        ut.appendChild(fk);
        ut.appendChild(document.createTextNode(x[1]));
        p.el.textContent = '';
        p.el.appendChild(ut);
      }
      m = x[0] === 'logo' ? logoMunur() : 0;
      lab = x[1] + (m ? ', ' + munurKr(m) : '');
      if (p.el.getAttribute('aria-label') !== lab) p.el.setAttribute('aria-label', lab);
      if (p.el.getAttribute('title') !== lab) p.el.setAttribute('title', lab);
    });
    (ST.snidPillur || []).forEach(function (p) {
      var Tm = SNID[p.k], l = Tm ? (erIslenska() ? tx(Tm.lysing) : heitiUtlit(p.k)) : '';
      if (p.el && l && p.el.getAttribute('title') !== l) p.el.setAttribute('title', l);
    });
  }

  var A = {
    gerd: 'svg', skuggi: false, lifandi: true,
    upphaf: function (ctx) {
      CTX = ctx;
      if (erTakkar(ctx)) stilar();
      var s0 = S(), q = {};
      try { (window.location.search || '').replace(/^\?/, '').split('&').forEach(function (p) { var a = p.split('='); if (a[0]) q[decodeURIComponent(a[0])] = decodeURIComponent(a[1] || ''); }); } catch (e) {}
      var listi = s0.utlit || [];
      ST.snid = listi.indexOf(q.utlit) >= 0 ? q.utlit : (s0.utlitD || listi[0] || 'safn');
      ST.efni = s0.efniD || 'tvilitt-hvitt'; ST.staerd = s0.staerdD || '120x75'; ST.logo = 'nei';
      /* lysandi slod (K3): ctx.afbUrSlod is true for the old ?variant= link too, not only the new readable params */
      var a = ctx.afbUrSlod ? ctx.afbrigdi : null;
      if (a && a.o) {
        ST.efni = hlutKodi('efni', a.o[stadur('efni')]) || ST.efni;
        ST.staerd = hlutKodi('staerd', a.o[stadur('staerd')]) || ST.staerd;
        ST.logo = logoAfKoda(a.o[stadur('logo')]) || 'nei';
      }
      var ls = ctx.skref('letur');
      if (ls) ls.el.addEventListener('change', function (e) { if (e.isTrusted) ST.leturSnert = true; });
      if (q.rammi === '1' || q.rammi === '0') ST.rammiSnert = true;
      var rs0 = ctx.skref('rammi');
      if (rs0) rs0.el.addEventListener('change', function () { ST.rammiSnert = true; });
      ctx.rot.addEventListener('sm:skra', function (e) {
        var d = e.detail || {}, skra = d.skra || null;
        if (d.eiginleiki && d.eiginleiki !== 'Logo') return;
        ST.logoSkra = skra; ST.logoMynd = null; ST.logoNr += 1;
        if (!skra) { ST.logoSkb = ''; ctx.breytt(); return; }
        ST.logoSkb = t('logo_hled', { f: skra.name || '' });
        ctx.breytt();
        var E = B(); if (!E) return;
        E.grafaLogo(skra, function (r) {
          if (ST.logoSkra !== skra) return;
          if (r && r !== 'stadgengill') { ST.logoMynd = r; ST.logoSkb = t('logo_komid', { f: skra.name || '' }); }
          else { ST.logoMynd = 'stadgengill'; ST.logoSkb = t(r === 'stadgengill' ? 'logo_stadgengill' : 'logo_olesanlegt', { f: skra.name || '' }); }
          ST.logoNr += 1;
          ctx.breytt();
        });
      });
      ctx.rot.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('[data-sm-skra-texti]')) ctx.breytt(); });
    },
    hlada: function (ctx) {
      CTX = ctx;
      if (HLADID) return HLADID;
      var E = B(), slod = V().snidmat;
      if (!E || !slod) return (HLADID = Promise.resolve(null));
      E.efni = V().efni || E.efni;
      HLADID = fetch(slod, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (j) {
          var listi = j.snid || j;
          (listi || []).forEach(function (Tm) { if (Tm && Tm.key) SNID[Tm.key] = Tm; });
          LISTI = (S().utlit || []).map(function (k) { return SNID[k]; }).filter(Boolean);
          if (!LISTI.length) LISTI = listi || [];
          if (!SNID[ST.snid] && LISTI[0]) ST.snid = LISTI[0].key;
          TILBUID = true;
          veljaSnid(ST.snid, ctx);
          ctx.breytt();
          return E.hlada(LISTI, { efni: E.efni });
        })
        .then(function () { LETUR_KLAR = true; ctx.flisar(); ctx.breytt(); })
        ['catch'](function (e) { if (window.console) console.warn('sm-vs-listaverk: snidmatin hlodust ekki', e && e.message); });
      return HLADID;
    },
    teikna: function (ctx, s) {
      CTX = ctx;
      if (!TILBUID) return;
      var Tm = T(), svg = svgAf(Tm, gogn(Tm, true, s), { spassia: 3, aria: '' }, s.rammi);
      if (ctx.teikning.__lvSvg !== svg) { ctx.teikning.innerHTML = svg; ctx.teikning.__lvSvg = svg; }
      if (erTakkar(ctx) && LISTI.length) { if (!ST.takkar) takkaSmida(ctx); ST.takkar.uppfaera(); takkaTexti(); }
    },
    lysing: function (s) {
      var Tm = T(); if (!Tm || !B()) return '';
      var D = gogn(Tm, true, s), hl = [], fal = {};
      (B().stada(Tm, D).falin || []).forEach(function (k) { fal[k] = 1; });
      REITIR.forEach(function (k) { if (k !== 'texti' && D[k] && !fal[k]) hl.push(D[k]); });
      return t('aria', { utlit: heitiUtlit(ST.snid), letur: CTX ? CTX.leturHeiti(s.letur) : '', efni: heitiEfni(ST.efni), staerd: heitiStaerd(ST.staerd), texti: hl.join(', ') });
    },
    /* 14.10 (samraeming): "Daemi" flagan a myndinni (kitid teiknar hana) medan synishornid er teiknad en ekkert hefur verid skrifad */
    daemi: function (s, ctx) { return !skrifad() ? ((ctx && ctx.vel && ctx.vel.ord && ctx.vel.ord.daemi_merki) || 'D\u00e6mi, skrifa\u00f0u \u00feinn texta') : false; },
    malband: function () { var m = staerdMm(ST.staerd); return m ? { b: m.b / 10, h: m.h / 10, eining: 'cm' } : null; },
    smamynd: function (s) { var Tm = T(); return TILBUID ? { svg: svgAf(Tm, gogn(Tm, false, s), { skuggi: false, spassia: 1, aria: '' }, s.rammi) } : null; },
    veggur: function () { return LJOST[ST.efni] ? 'dokkur' : 'ljos'; },
    afbrigdi: function (s) { var a = finna(val(s, { rammi: rammiNu(s) })); return a ? { id: a.id } : null; },
    hjalp: function (s) {
      var Tm = T(), EF = B() && B().EFNI ? B().EFNI[ST.efni] : null;
      var um = t('efnil.' + ST.efni) + '. ' + (EF && EF.fj === 'malmur' ? t('efni_malmur_texti') : t('efni_akryl_texti')) + (ISO_LITIR[ST.efni] ? ' ' + t('efni_litir_texti') : '') + ' ' + t('horn_texti') + ' ' + t('festing_heiti') + ': ' + t('festing');
      return { snid: (Tm && t('lysing.' + Tm.key)) || (Tm ? tx(Tm.lysing) : ''), efni: um, staerd: t('staerd_lys.' + ST.staerd) };
    },
    slod: function () { return { utlit: ST.snid || null }; },
    rammi: function () { var Tm = T(); return TILBUID ? rammiGeo(Tm, ST.efni) : { gerd: null }; },
    syna: function (lykill) {
      if (lykill === 'logoskra') return ST.logo === 'ja';
      return undefined;
    },
    athuga: function (s) {
      var ut = [];
      if (!trim(ST.nafn)) ut.push({ kodi: 'vantar_nafn', reitur: 'upplysingar', stopp: true, texti: t('vantar_nafn'), hnappur: t('vantar_nafn'), strax: ST.snert });
      if (LETUR_KLAR) (stadaNu(s).vandamal || []).forEach(function (v) {
        if (v.kodi === 'vantar' && v.reitur === 'nafn') return;
        ut.push({ kodi: v.kodi + (v.reitur ? ':' + v.reitur : ''), reitur: 'upplysingar', stopp: !!v.stopp, texti: vTexti(v), hnappur: v.stopp ? t('of_langt') : '', strax: true });
      });
      return ut;
    },
    eiginleikar: function (s, ctx) {
      var Tm = T(), E = B(), D = gogn(Tm, false, s), p = E.eiginleikar(Tm, D), ut = [], k;
      for (k in p) if (has(p, k)) {
        if (k === t('eig_letur')) ut.push([k, ctx.leturHeiti(s.letur)]);
        else ut.push([k, p[k]]);
      }
      if (s.rammi && rammiGeo(Tm, ST.efni).gerd) { var rs = ctx.skref('rammi'), r = rs && rs.el.querySelector('input:checked'); if (r) ut.push([ctx.eiginleiki('rammi') || t('eig_rammi'), r.getAttribute('data-nafn') || '']); }
      var aths = trim(s.aths);
      if (aths) ut.push([ctx.eiginleiki('aths') || t('eig_aths'), aths]);
      return ut;
    },
    framleidsla: function (s) {
      var E = B(), Tm = T(); if (!E || !Tm) return null;
      var D = gogn(Tm, false, s), f = E.framleidsla(Tm, D, { logo: ST.logo === 'ja' ? (ST.logoSkra ? 'skra' : 'lysing') : null });
      f.tungumal = (document.documentElement.getAttribute('lang') || 'is').slice(0, 5);
      var g = rammiGeo(Tm, ST.efni);
      if (g.gerd) f.rammi = s.rammi === 'med' ? (g.gerd === 'malmur' ? { gerd: 'malmur', inset: g.inset, band: g.band } : { gerd: 'lina', inset: g.inset }) : false;
      /* the exact frame pieces (mm, plate origin top left) and the workshop line, from the same numbers as the preview */
      var m = staerdMm(ST.staerd);
      if (f.rammi && m && window.SMVelSida && window.SMVelSida.rammi) {
        var R = window.SMVelSida.rammi(m.b, m.h, { gerd: g.gerd, inset: g.inset, insetY: g.insetY, r: g.r, form: g.form, band: g.band });
        f.rammi.hlutir = R.hlutir; f.rammi.lysing = R.lysing;
      }
      /* 02.10: the production FILE (SMFram) as on the bag tag page: the template's pieces from SMBarm.smfram (text as
         outlines, rules, logo mask or placement box, outline), the frame pieces from SMVelSida.rammi, and the record f
         above as the _framleidsla JSON next to it (the engine posts spec.json as _framleidsla). When the spec cannot
         be made, the record alone goes, as before. */
      try {
        var F = window.SMFram; framLetur();
        var O = { logo: ST.logo === 'ja' ? (ST.logoSkra ? 'skra' : 'lysing') : null };
        if (!F || !F.baetaVid || !E.smfram) return { json: f };
        if (ST.logo === 'ja') {
          if (ST.logoSkra) O.logoNafn = ST.logoSkra.name || '';
          if (ST.logoMynd && ST.logoMynd.mynd) O.logoMynd = ST.logoMynd.mynd;
          if (!ST.logoSkra) O.logoLysing = logoLysing();
        }
        var sp = E.smfram(Tm, D, O);
        var spec = { vara: sp.vara, efni: sp.efni, staerd: sp.staerd, snid: sp.snid, ord: sp.ord, w: sp.w, h: sp.h, lysing: sp.lysing.slice(), hlutir: sp.hlutir.slice(), json: f };
        if (f.rammi && f.rammi.hlutir && f.rammi.hlutir.length) {
          var ytri = spec.hlutir.pop();
          spec.hlutir = spec.hlutir.concat(f.rammi.hlutir, [ytri]);
          if (f.rammi.lysing) spec.lysing.push(f.rammi.lysing);
        }
        if (!spec.hlutir.length || !spec.w || !spec.h) return { json: f };
        return spec;
      } catch (e) { try { console.warn('[SMFram] listaverk: ' + (e && e.message)); } catch (x) {} return { json: f }; }
    },
    framTimi: 12000,
    forhlada: function (s) { try { var E = B(), Tm = T(); framLetur(); if (window.SMFram && window.SMFram.forhlada && E && Tm && TILBUID && E.smfram) window.SMFram.forhlada(E.smfram(Tm, gogn(Tm, false, s), {})); } catch (e) {} },
    vandamal: function (v, ctx) {
      var el = ctx.skref('upplysingar'); el = el && el.el.querySelector('[data-vs-sersnid]');
      if (!el) return;
      REITIR.forEach(function (k) {
        var inp = el.querySelector('[data-lv-texti="' + k + '"]'); if (!inp) return;
        var bad = v.some(function (x) { return x.stopp && x.kodi && (x.kodi === 'vantar_nafn' ? k === 'nafn' && (ctx.reynt() || ST.snert) : String(x.kodi).split(':')[1] === k); });
        inp.setAttribute('aria-invalid', bad ? 'true' : 'false');
        if (bad) opnaFyrir(inp);
      });
      var box = el.querySelector('[data-lv-tillogur]');
      if (box) {
        var stop = LETUR_KLAR && trim(ST.nafn) ? (stadaNu(stadaFyrir()).vandamal || []).filter(function (x) { return x.stopp; }) : [], h = '';
        if (stop.length) {
          var till = tillogur(stadaFyrir());
          if (till.length) h = tillHtml(ctx, till, 'lv-til');
        }
        ctx.html.setja(box, h);
      }
    },
    utlit: {
      teikna: function (s2, ctx, o) {
        if (!TILBUID) return null;
        var Tm = T(), ov = {}, rammi = s2.rammi, O = { skuggi: false, spassia: 1.5, aria: '' };
        if (o.lykill === 'snid') { Tm = SNID[o.gildi] || Tm; ov.letur = leturAf(Tm, s2); }
        if (o.lykill === 'efni') ov.efni = o.gildi;
        if (o.lykill === 'staerd') ov.staerd = o.gildi;
        var D = gogn(Tm, true, s2, ov);
        if (o.tegund === 'rammi') rammi = s2.rammi;
        else if (o.lykill === 'efni' || o.lykill === 'snid') {
          /* the frame this tile would get: the customer's choice within the same material class, else that class's default */
          var R = rammiGeo(Tm, D.efni), Rn = rammiGeo(T(), ST.efni);
          if (!R.gerd) rammi = 'an';
          else if (R.gerd !== Rn.gerd) rammi = R.gerd === 'malmur' ? (S().rammiMalmur || 'an') : 'med';
        }
        var svg = svgAf(Tm, D, O, rammi, true);
        if (o.lykill === 'staerd') {
          var m = staerdMm(o.gildi), p = 1.5, W0 = 120 + 2 * p, H0 = 100 + 2 * p;
          if (m) svg = svg.replace(/viewBox="[^"]*"/, 'viewBox="' + r3(-p) + ' ' + r3(-p - (H0 - m.h - 2 * p) / 2) + ' ' + r3(W0) + ' ' + r3(H0) + '"');
        }
        if (o.lykill === 'efni') svg = naermynd(svg, staerdMm(D.staerd));
        return { svg: svg };
      },
      lykill: function (s2, ctx, o) {
        var ov = {};
        if (o.lykill === 'efni') ov.efni = o.gildi;
        if (o.lykill === 'staerd') ov.staerd = o.gildi;
        var Tm = o.lykill === 'snid' ? SNID[o.gildi] : T();
        return JSON.stringify([o.lykill, o.gildi, o.tegund, Tm ? Tm.key : '', gogn(Tm, true, s2, ov), s2.letur, s2.rammi, ctx.rammiGildi(), ST.logoNr]);
      }
    },
    letur: {
      texti: function () { return trim(ST.nafn).replace(/\s{2,}/g, ' '); },
      css: function (id) {
        var k = leturKey(id), Tm = T(), L = null;
        if (Tm && k) L = k === Tm.letur_sjalfgefid ? Tm.letur && Tm.letur.nafn : Tm.letur_val[k] && Tm.letur_val[k].letur && Tm.letur_val[k].letur.nafn;
        if (!L) return null;
        return { fontFamily: "'" + (({"Dancing Script":"SM Skrift","IBM Plex Mono":"SM Mono"})[L.family] || L.family) + "', " + (/garamond/i.test(L.family) ? 'serif' : /mono/i.test(L.family) ? 'monospace' : 'sans-serif'), fontWeight: String(L.weight || 400), fontStyle: L.style === 'italic' ? 'italic' : 'normal', textTransform: L.caps ? 'uppercase' : 'none', letterSpacing: L.tracking_em ? L.tracking_em + 'em' : 'normal' };
      },
      flotur: function () { var E = B() && B().EFNI && B().EFNI[ST.efni]; return E ? { bak: E.flotur, blek: E.kjarni } : null; },
      falid: true
    },
    skref: {
      snid: {
        teikna: function (el, s, ctx) {
          if (!LISTI.length) return;
          var k = LISTI.map(function (Tm) { return { gildi: Tm.key, heiti: heitiUtlit(Tm.key), valid: Tm.key === ST.snid }; });
          ctx.html.setja(el, ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-snid', birting: 'utlit', lykill: 'snid', dalkar: 2, kostir: k }));
          Array.prototype.forEach.call(el.querySelectorAll('input'), function (i) { i.checked = i.value === ST.snid; });
          tengja(el, function (x) { veljaSnid(x.value, ctx); ctx.breytt(); });
        },
        gildi: function () { return heitiUtlit(ST.snid); },
        buid: function () { return !!ST.snid; }
      },
      upplysingar: {
        teikna: function (el, s, ctx) {
          smidaReiti(el, ctx);
          var nr = el.querySelector('[data-lv-reitur="nr"]'); if (nr) nr.hidden = !notarNr(T());
          if (erTakkar(ctx) && !ST.meiraSnert && meiraHefurGildi(el)) { var dt = el.querySelector('[data-lv-meira]'); if (dt && !dt.open) dt.open = true; }
          var R = T() && T().reitir;
          if (R) REITIR.forEach(function (k) { var i = el.querySelector('[data-lv-texti="' + k + '"]'); if (i && R[k] && R[k].max && i.maxLength !== R[k].max) i.maxLength = R[k].max; });
        },
        gildi: function () { return trim(ST.nafn); },
        buid: function (s) { return !!trim(ST.nafn) && !(LETUR_KLAR && (stadaNu(s).vandamal || []).some(function (x) { return x.stopp; })); },
        fokus: function (el, kodi) {
          var k = String(kodi || '').split(':')[1] || 'nafn';
          var mark = el.querySelector('[data-lv-texti="' + k + '"]') || el.querySelector('[data-lv-texti="nafn"]');
          opnaFyrir(mark);
          return mark;
        }
      },
      efni: {
        teikna: function (el, s, ctx) {
          var E = B(), ak = [], mm = [];
          kodar('efni').forEach(function (k) {
            var a = finna(val(s, { efni: k, rammi: rammiEfnis(s, k) })), EF = E && E.EFNI ? E.EFNI[k] : null;
            var x = { gildi: k, heiti: heitiEfni(k), undir: a ? kr(a.verd) : t('ekki_i_bodi'), valid: k === ST.efni, ovirkt: !a || a.til === false, ekki: !a,
              hopur: EF && EF.fj === 'malmur' ? t('efni_malmur') : t('efni_akryl') };
            (EF && EF.fj === 'malmur' ? mm : ak).push(x);
          });
          ctx.html.setja(el, ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-efni', birting: 'utlit', lykill: 'efni', dalkar: 3, kostir: ak.concat(mm) }));
          Array.prototype.forEach.call(el.querySelectorAll('input'), function (i) { i.checked = i.value === ST.efni; });
          tengja(el, function (x) { ST.efni = x.value; ctx.breytt(); });
        },
        gildi: function () { return heitiEfni(ST.efni); },
        buid: function () { return !!ST.efni; }
      },
      staerd: {
        teikna: function (el, s, ctx) {
          var k = kodar('staerd').map(function (sk) {
            var a = finna(val(s, { staerd: sk }));
            return { gildi: sk, heiti: heitiStaerd(sk), undir: a ? kr(a.verd) : '', valid: sk === ST.staerd, ovirkt: !a || a.til === false, ekki: !a };
          });
          ctx.html.setja(el, ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-staerd', birting: 'utlit', lykill: 'staerd', dalkar: 3, kostir: k }));
          Array.prototype.forEach.call(el.querySelectorAll('input'), function (i) { i.checked = i.value === ST.staerd; });
          tengja(el, function (x) { ST.staerd = x.value; ctx.breytt(); });
        },
        gildi: function () { return heitiStaerd(ST.staerd); },
        buid: function () { return !!ST.staerd; }
      },
      logo: {
        teikna: function (el, s, ctx) {
          var m = munur(s, { logo: 'nei' }, { logo: 'ja' }), a = finna(val(s, { logo: 'ja' }));
          var h = ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-logo', dalkar: 2, kostir: [
            { gildi: 'nei', heiti: t('logo_nei'), valid: ST.logo !== 'ja' },
            { gildi: 'ja', heiti: t('logo_ja'), undir: m ? munurKr(m) : '', valid: ST.logo === 'ja', ovirkt: !a || a.til === false, ekki: !a }] });
          if (ST.logo === 'ja' && ST.logoSkb) h += '<p class="vs-hjalp" aria-live="polite">' + esc(ST.logoSkb) + '</p>';
          ctx.html.setja(el, h);
          tengja(el, function (x) { ST.logo = x.value; ctx.breytt(); });
        },
        gildi: function (s) { var m = munur(s, { logo: 'nei' }, { logo: 'ja' }); return ST.logo === 'ja' ? t('logo_ja') + (m ? ' (' + munurKr(m) + ')' : '') : t('logo_nei'); },
        buid: function () { return true; },
        kodi: function () { return ST.logo === 'ja' ? 'ja' : 'nei'; }
      }
    }
  };
  if (window.SMVelSida) window.SMVelSida.skra('listaverk', A);
  else (window.SMVelSidaBid = window.SMVelSidaBid || []).push(['listaverk', A]);
})();
